import { IBudget } from 'modules/checkout/domain/entities';
import { TPaymentMethodType } from 'shared/domain/entities';

export default function getPaymentMethodOffers(
  budget: IBudget,
  payingMethod: TPaymentMethodType | null,
): TPaymentMethodType[] {
  if (!payingMethod) return [];

  const offers = budget.paymentMethodOffers.offers[payingMethod] ?? [];

  return offers.filter(offer =>
    budget.paymentMethods.some(paymentMethod => paymentMethod.key === offer),
  );
}
